<i18n>
en:
  title: "Check-in"
  message:
    operation: "Please read your QR code."
    success: "Please store your luggage."
  error:
    WCI001: "Failed to read. <br> May differ from the check-in QR code."
    WCI002: "Reservation date is incorrect. <br> Please scan the QR code for today's reservation."
    WCI003: "Possible QR code for checkout <br> Please load the QR code for check-in."
ja:
  title: "チェックイン"
  message:
    operation: "お客様のQRコードを読み込んでください。"
    success: "お客様の荷物の保管をお願いします。"
  error:
    WCI001: "読取に失敗しました。<br>チェックインQRコードと異なる可能性があります。"
    WCI002: "予約日が正しくありません。<br>本日予約のQRコードを読み取ってください。"
    WCI003: "チェックアウト用のQRコードの可能性があります<br>チェックイン用のQRコードを読み込んでください。"
</i18n>

<template lang="pug">
  div
    h1.white--text.text-center|{{$t('title')}}

    v-container
      v-row
        v-col(cols="12" align="center")
          p(v-if="isSuccess")
            strong|{{$t('message.success')}}
          p.pink--text(v-else)|{{$t('message.operation')}}

        //- エラーメッセージ
        template(v-if="errMsg")
          v-col(cols="12" align="center")
            v-alert.d-inline-block(dense outlined type="error")
              div(v-html="errMsg")

        //- 読込中
        template(v-if="isSubmit")
          v-col.my-12.pa-12(cols="12" align="center")
            v-progress-circular(indeterminate :size="100" :width="10" color="primary")

        //- 成功
        template(v-else-if="isSuccess")
          v-col.my-12.pa-12(cols="12" align="center")
            v-icon.success-icon(color="teal accent-2")|fa-check

        //- 予約リスト
        template(v-else)
          v-col(cols="12")
            QrcodeStream.camera-view(@decode="submit")
</template>

<script>
import {QrcodeStream} from 'vue-qrcode-reader'

export default {
  components: {
    QrcodeStream
  },
  data () {
    return {
      // 送信中
      isSubmit: false,
      // 成功
      isSuccess: false,
      // エラーメッセージ
      errMsg: null
    }
  },
  methods: {
    submit (reserve) {
      this.isSubmit = true
      this.isSuccess = false
      this.errMsg = null

      this.api.checkIn({
        reserve
      })
        .then(response => {
          this.isSuccess = true
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isSubmit = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>
h1
  font-size: 48px
  text-shadow: 0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444,0 0 1px #444444
  word-break: keep-all

.camera-view
  width: 100%
  height: 100%

.success-icon
  font-size: 200px
</style>
